import React, { useRef, useState } from "react";
import { useLanguage } from "../../../contexts";
import "./FileDropzone.scss";

const BTN = {
  border: "none", borderRadius: "20px", padding: "10px 30px",
  fontSize: "14px", fontWeight: 600, fontFamily: "'Archivo', sans-serif", cursor: "pointer",
};

export function FileDropzone({ onUpload, uploading, onCancel, accept, supportedLabel }) {
  const inputRef = useRef(null);
  const [dragging, setDragging] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const handleFiles = (files) => {
    if (!files?.length) return;
    setSelectedFiles(Array.from(files));
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    handleFiles(e.dataTransfer.files);
  };

  const handleSubmit = () => {
    if (selectedFiles.length) onUpload(selectedFiles);
  };

  return (
    <div className="file-dropzone">
      <div
        className={`file-dropzone__zone${dragging ? " file-dropzone__zone--active" : ""}`}
        onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
        onDragLeave={() => setDragging(false)}
        onDrop={handleDrop}
        onClick={() => inputRef.current?.click()}
      >
        <div className="file-dropzone__icon">
          <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="32" fill="#3B82F6" fillOpacity="0.12" />
            <path d="M32 44V28M32 28l-6 6M32 28l6 6" stroke="#3B82F6" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M20 38c-3.3 0-6-2.7-6-6a6 6 0 015.1-5.9A10 10 0 0132 18a10 10 0 0112.9 8.1A6 6 0 0150 32c0 3.3-2.7 6-6 6H20z" fill="#3B82F6"/>
          </svg>
        </div>
        <p className="file-dropzone__text">{t("drag_drop_text")}</p>
        {selectedFiles.length > 0 && (
          <ul className="file-dropzone__list">
            {selectedFiles.map((f, i) => <li key={i}>{f.name}</li>)}
          </ul>
        )}
        <div className="file-dropzone__separator"><span>o</span></div>
        <button
          className="file-dropzone__btn"
          type="button"
          onClick={(e) => { e.stopPropagation(); inputRef.current?.click(); }}
          style={{ ...BTN, background: "#1e3a5f", color: "#fff" }}
        >
          <span className="file-dropzone__btn-icon">&#128193;</span> {t("select_files")}
        </button>
        {supportedLabel && (
          <p className="file-dropzone__supported">{supportedLabel}</p>
        )}
        <input
          ref={inputRef}
          type="file"
          multiple
          accept={accept}
          style={{ display: "none" }}
          onChange={(e) => handleFiles(e.target.files)}
        />
      </div>

      <div className="file-dropzone__actions">
        {selectedFiles.length > 0 && (
          <button
            type="button"
            disabled={uploading}
            onClick={handleSubmit}
            style={{ ...BTN, background: "#4A7FA5", color: "#fff", opacity: uploading ? 0.55 : 1, cursor: uploading ? "not-allowed" : "pointer" }}
          >
            {uploading ? "…" : t("upload")}
          </button>
        )}
        <button
          type="button"
          disabled={uploading}
          onClick={onCancel}
          style={{ ...BTN, background: "#9BAFC4", color: "#fff", opacity: uploading ? 0.55 : 1, cursor: uploading ? "not-allowed" : "pointer" }}
        >
          {t("cancel")}
        </button>
      </div>
    </div>
  );
}
